import LoadingComponent from 'Components/HelperComponents/LoadingComponent'
import { useAccreditacioEntities } from 'hooks/useAccreditacioEntities'
import { useEdition } from 'hooks/useEdition'
import Button from 'NewVersion/components/UI/Buttons/Button'
import { AcreditacionsIcon } from 'NewVersion/icons/AcreditacionsIcon'
import { PremsaIcon } from 'NewVersion/icons/PremsaIcon'
import 'NewVersion/styles/Acreditacions.scss'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import {
  CREATE_ENTITY_PATH,
  REGISTER_ENTITY_PERFORMING_SELECT_PATH,
  REGISTER_ENTITY_PROFESSIONAL_REUSE_PATH,
} from 'Routes/Paths'
import { ACCREDITATION_TYPE } from 'utils/constants'

const LandingPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { currentEdition, loading: loadingCurrentEdition } = useEdition()
  const {
    nonPerforming,
    accreditationCase,
    loading: loadingEntities,
    error,
  } = useAccreditacioEntities()

  if (loadingCurrentEdition || loadingEntities) {
    return <LoadingComponent />
  }

  if (error) {
    return (
      <div className="acreditacions page-wrapper">
        <h1>{t('acreditacions')}</h1>
        <p>
          {t('error_loading_accreditation', 'An error occurred loading your accreditation data')}
        </p>
      </div>
    )
  }

  const handleProfessionalClick = () => {
    if (accreditationCase === ACCREDITATION_TYPE.performing) {
      if (nonPerforming.length > 0) {
        navigate(REGISTER_ENTITY_PROFESSIONAL_REUSE_PATH)
      } else {
        navigate(`${CREATE_ENTITY_PATH}/professional`)
      }
    } else if (accreditationCase === ACCREDITATION_TYPE.non_performing) {
      navigate(REGISTER_ENTITY_PROFESSIONAL_REUSE_PATH)
    } else {
      navigate(`${CREATE_ENTITY_PATH}/professional`)
    }
  }

  return (
    <div className="acreditacions page-wrapper">
      <h1>{t('acreditacions')}</h1>

      {accreditationCase === ACCREDITATION_TYPE.performing ? (
        <div className="acreditacions-landing acreditacions-landing--split">
          <section className="acreditacions-section acreditacions-section--primary">
            <div className="acreditacions-buttons acreditacions-buttons--primary">
              <Button
                color="primary"
                type="button"
                dataTest="btnAddArtistaManagerEntityTest"
                icon={<AcreditacionsIcon fill="white" />}
                onClick={() => navigate(REGISTER_ENTITY_PERFORMING_SELECT_PATH)}
              >
                {t('accredit_as_performing', 'Accredit as performing entity')}
              </Button>
            </div>
          </section>
          <section
            className="acreditacions-section acreditacions-section--secondary"
            aria-label={t('acreditacions_intro_professional_optional')}
          >
            <p className="acreditacions-section__intro acreditacions-section__intro--secondary">
              {t('acreditacions_intro_professional_optional')}
            </p>
            <div className="acreditacions-buttons acreditacions-buttons--secondary">
              <Button
                color="primary"
                variant="outlined"
                type="button"
                size="small"
                dataTest="btnAddProfessionalEntityTest"
                icon={<AcreditacionsIcon />}
                onClick={handleProfessionalClick}
                disabled={!currentEdition.canCreateEnsProfessionals()}
              >
                {t('Professionals')}
              </Button>
              <Button
                color="primary"
                variant="outlined"
                type="button"
                size="small"
                dataTest="btnAddPressEntityTest"
                icon={<PremsaIcon />}
                onClick={() => navigate(`${CREATE_ENTITY_PATH}/premsa`)}
                disabled={!currentEdition.canCreateEnsPremsa()}
              >
                {t('premsa')}
              </Button>
            </div>
          </section>
        </div>
      ) : (
        <div className="acreditacions-buttons">
          <Button
            color="primary"
            type="button"
            dataTest="btnAddProfessionalEntityTest"
            icon={<AcreditacionsIcon fill="white" />}
            onClick={handleProfessionalClick}
            disabled={!currentEdition.canCreateEnsProfessionals()}
          >
            {t('Professionals')}
          </Button>
          <Button
            color="primary"
            type="button"
            dataTest="btnAddPressEntityTest"
            icon={<PremsaIcon />}
            onClick={() => navigate(`${CREATE_ENTITY_PATH}/premsa`)}
            disabled={!currentEdition.canCreateEnsPremsa()}
          >
            {t('premsa')}
          </Button>
        </div>
      )}
    </div>
  )
}

export default LandingPage
